// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"691f29b4","84":"e135ac08","98":"5ae0606d","161":"0158570c","440":"9d560f7d","524":"3a6c2d36","569":"e0549151","873":"5ae0606d","891":"dcd965bb","939":"388c2a00"}[chunkId] + ".chunk.css";
};